/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNaviChartfunnel = (props: Props) => (
  <Icon viewBox="0 0 25 24" {...props}>
    <g fill="none">
      <path
        d="M1.498 2h2v18h18v2h-20zm8 11c0-7.812-3.19-9-4-9V2h16v2c-1.314 0-2.335 1.076-3.06 3.089-.697 1.939-.94 4.314-.94 5.911v5h-8zm8.306-9H9.127c.6.753 1.137 1.74 1.548 3h5.685c.062-.199.127-.395.197-.589.3-.834.706-1.683 1.246-2.411zm-1.931 5H11.17c.161.898.269 1.895.31 3h4.043a22.88 22.88 0 0 1 .349-3zm-.375 5h-4v2h4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNaviChartfunnel as NaviChartfunnel };
